import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const StatCard = ({ title, value, change, changeType, icon: Icon, color = 'blue', variant = 'default' }) => {
  const colorClasses = {
    blue: 'bg-primary-100 text-primary-700 dark:bg-surface-container-high dark:text-primary',
    green: 'bg-emerald-100 text-emerald-800 dark:bg-tertiary/15 dark:text-tertiary',
    red: 'bg-red-100 text-red-700 dark:bg-error/15 dark:text-error',
    yellow: 'bg-amber-100 text-amber-800 dark:bg-primary-fixed-dim/15 dark:text-primary-fixed-dim',
  };

  const getChangeIcon = () => {
    if (changeType === 'increase') return <TrendingUp className="h-4 w-4" />;
    if (changeType === 'decrease') return <TrendingDown className="h-4 w-4" />;
    return <Minus className="h-4 w-4" />;
  };

  const changeTone =
    changeType === 'increase'
      ? 'text-emerald-600 dark:text-tertiary'
      : changeType === 'decrease'
        ? 'text-red-600 dark:text-error'
        : 'text-slate-600 dark:text-on-surface-variant';

  if (variant === 'glass') {
    return (
      <div className="rounded-3xl border border-white/15 bg-white/10 p-5 shadow-lg backdrop-blur-xl transition-colors dark:border-white/10 dark:bg-white/5 dark:shadow-none">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="label-intel text-xs text-slate-600 dark:text-on-surface-variant">{title}</p>
            <p className="mt-1 font-headline text-2xl font-bold tracking-tight text-slate-900 dark:text-on-surface">
              {value}
            </p>
            {change !== undefined && (
              <div className={`mt-1 flex items-center text-xs ${changeTone}`}>
                {getChangeIcon()}
                <span className="ml-1 line-clamp-2">{change}</span>
              </div>
            )}
          </div>
          {Icon && (
            <div className={`shrink-0 rounded-2xl p-2.5 ${colorClasses[color]}`}>
              <Icon className="h-5 w-5" />
            </div>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-stitch-xl border border-slate-200/80 bg-white p-6 shadow-intel-glow transition-colors dark:border-outline-variant/15 dark:bg-surface-container dark:shadow-none">
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0">
          <p className="label-intel text-slate-500 dark:text-on-surface-variant">{title}</p>
          <p className="mt-2 font-headline text-3xl font-bold tracking-tight text-slate-900 dark:text-on-surface">
            {value}
          </p>
          {change !== undefined && (
            <div className={`mt-2 flex items-center text-sm ${changeTone}`}>
              {getChangeIcon()}
              <span className="ml-1">{change}</span>
            </div>
          )}
        </div>
        {Icon && (
          <div className={`shrink-0 rounded-full p-3 ${colorClasses[color]}`}>
            <Icon className="h-6 w-6" />
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
